export default {
      id: "cc-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#cc",
      toString: function () {
        return this.url;
      }
    }